'use client';
var classes = {"root":"m-77c9d27d","inner":"m-80f1301b","loader":"m-a25b86ee","label":"m-811560b9","section":"m-a74036a","group":"m-80d6d844"};

export { classes as default };
//# sourceMappingURL=Button.module.css.mjs.map
